export const ONLINE = 1;

// RELATORIOS
export const REL_ABASTECIMENTO = 1;
export const REL_LUBRIFICACAO = 2;
export const REL_TRANSFERENCIA = 3;
export const REL_VAZAONAOAUTORIZADA = 4;
export const REL_ALARME_SISTEMA = 5;
export const REL_RECEBIMENTO = 6;

// ALARMES
export const ALARME_ALTERACAOMODOOPERACIONAL = 1;
export const ALARME_DESEMPENHOFROTAFORAMEDIA = 2;
export const ALARME_DESEMPENHOMOTORISTAFORAMEDIA = 3;
export const ALARME_DIVERGENCIALIBERACAOMOVIMENTACAO = 4;
export const ALARME_DIVERGENCIARECEBIMENTO = 5;
export const ALARME_DIVERGENCIATRANSFERENCIACOMBOIO = 6;
export const ALARME_DIVERGENCIATURNO = 7;
export const ALARME_IRREGULARIDADEDBIC = 8;
export const ALARME_MOVIMENTACAODIGITADA = 9;
export const ALARME_MOVIMENTACAOFORATURNO = 10;
export const ALARME_TANQUE = 11;
export const ALARME_VAZAONAOAUTORIZADA = 12;
export const ALARME_PAUSAS_DBIC = 18;
export const ALARME_ESTOURO_SLA_ATENDIMENTO = 19;

// SENHAS
export const SENHA_MAXIMO = 30;
